module.exports = __webpack_public_path__ + "static/media/honda_centros_icon.29a30a61.svg";